import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.computer-protection', {
        url: '/computerProtection',
        component: 'companyComputerProtection',
        resolve: {
            applications,
        },
    });
}

/** @ngInject */
function applications(ApplicationsResource, companyId) {
    return ApplicationsResource.getAllComputerProtectionApplicationsForCompany(companyId);
}



// WEBPACK FOOTER //
// ./src/portal/states/company/computer-protection/computer-protection.state.js